import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class serviceProviderService extends GenericService {
  constructor() {
    super('/sps', axiosInstance);
  }
}

export default new serviceProviderService(); 